
import { useState, useEffect } from "react";
import { getImageGuideFor } from './inappImage';
import { useAppStore } from "../../store/models/app";
import useUIStates from '../../store/models/uistates/useUIStates';

function useInAppGuide () {

    const {
        selectedCalendar,
    } = useUIStates();
    const appStore = useAppStore();

    const [imageURL, setImageURL] = useState('');

    useEffect(() => {
        const os = appStore.userAgent?.os?.name?.toLowerCase();
        const appName = appStore.appName || appStore.getAppName();
        const options = { app: appName };
        const url = getImageGuideFor(os, selectedCalendar, options);
        setImageURL(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCalendar, appStore.fingerprint]);

    return {
        imageURL,
    };
}

export default useInAppGuide;
